import { Center, Heading, Flex } from "@chakra-ui/react";
import { FaLock } from "react-icons/fa";

const NoSubscriptionComponent = () => {
  return (
    <Center mt={5}>
      <Flex direction="column" alignItems="center">
        <FaLock size={25} />
        <Heading size="md" mt={3}>
          You need a subscription to access this data.
        </Heading>
      </Flex>
    </Center>
  );
};

export default NoSubscriptionComponent;
